export default "__VITE_ASSET__Cfm2xjKa__"